import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type {
	LWApiPublicAccountNetworkPrivateListParamsRaw,
	LWApiPublicAccountNetworkPrivateListResultRaw,
} from '@liquidweb-dev/club-sauce/public/account/network/private/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const ACCOUNT_NETWORK_PRIVATE_LIST_QUERY_KEY =
	'/account/network/private/list';

const useAccountNetworkPrivateList = <
	TData = LWApiPublicAccountNetworkPrivateListResultRaw,
>(
	params: LWApiPublicAccountNetworkPrivateListParamsRaw,
	options?: UseQueryOptions<
		LWApiPublicAccountNetworkPrivateListResultRaw,
		ApiErrorI,
		TData
	>,
) =>
	useQuery({
		queryKey: [ACCOUNT_NETWORK_PRIVATE_LIST_QUERY_KEY, params],
		queryFn: () => api.account.network.private.apiRaw.list(params),
		...options,
	});

export default useAccountNetworkPrivateList;
